import { useRuntimeConfig } from '#imports'

// The only caller of useRuntimeConfig(). Read it where the value is used, never
// when a module is imported: the Nuxt app does not exist yet at that point.
export function publicConfig() {
    return useRuntimeConfig().public
}
